<template>
  <div v-if="job">
    <b>Details</b>
    <div>
      Accepted Quote Amount:
      {{ job.invoice ? dollars(job.invoice.financials.total_cents) : "--" }}
    </div>
    <div>
      Permit:
      <a :href="permitPath" data-remote="true">{{ permitStatus }}</a>
    </div>
    <div>Status: {{ workCompleteStatus }}</div>
  </div>
</template>

<script>
import CONSTANTS from "@/Constants.js";

export default {
  props: {
    job: {
      type: Object,
      default: null
    }
  },
  computed: {
    permitStatus() {
      if (this.job.permits.length === 0) {
        return "N/A";
      }
      return CONSTANTS.PERMIT_STATUS_MAP[this.job.permits[0].status];
    },
    permitPath() {
      if (this.job.permits.length === 0) {
        return `/permits/new?permit%5Bjob_id%5D=${this.job.id}`;
      }
      return `/permits/${this.job.permits[0].id}`;
    },
    workCompleteStatus() {
      return this.job.completed_signature ? "Complete" : "In Progress";
    }
  },
  methods: {
    toggleModal(modal) {
      this[modal] = !this[modal];
    }
  }
};
</script>

<style lang="scss" scoped></style>
